import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';

import './ModalV2.scss';

const ModalV2 = props => {
  const {
    className,
    show,
    handleConfirm,
    handleToggle,
    children,
    footer,
    confirmText,
    confirmClassname,
  } = props;

  return (
    <Modal
      hideButton
      show={show}
      onToggle={handleToggle}
      className={`save-confirmation-modal ${className}`}
      footer={
        <div className="d-flex flex-column w-100">
          <Button
            color={confirmClassname || 'primary'}
            className="mb-3"
            onClick={handleConfirm}
          >
            {confirmText || 'Save'}
          </Button>
          <Button color="light" className="text-dark" onClick={handleToggle}>
            <FontAwesomeIcon icon={faArrowLeft} className="mr-2" /> {footer}
          </Button>
        </div>
      }
    >
      <h2>
        Are you sure you want
        <br /> to proceed?
      </h2>
      <hr />
      <div className="save-confirmation-modal-content">{children}</div>
    </Modal>
  );
};

ModalV2.propTypes = {
  className: PropTypes.string,
  show: PropTypes.bool.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  handleToggle: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node.isRequired,
  confirmText: PropTypes.string,
  confirmClassname: PropTypes.string,
};

ModalV2.defaultProps = {
  className: '',
  confirmText: null,
  confirmClassname: null,
};

export default ModalV2;
